import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import SupplierListView from '@components/shared/suppliers/SupplierListView'
import ListPageHeader from '@shared/ListPageHeader'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { supplierService } from '@services/admin/supplierService'

export default function AdminSupplierList() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['suppliers', 'suppliers.list']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/suppliers/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <SupplierListView
        service={supplierService}
        role="admin"
      />
    </div>
  )
}
